<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="alert alert-warning" role="alert" v-if="!mensagemSolicitacao">
          <p v-if="!mensagemSolicitacao">* As solicitações têm até 5 dias úteis para serem aprovadas.</p>          
        </div>
        <div class="alert alert-danger" role="alert" v-if="mensagemSolicitacao">
          <p v-if="mensagemSolicitacao" v-html="mensagemSolicitacao"></p>          
        </div>

        <div class="alert alert-info" role="alert">
          <p>Para começar, escolha 1 item em "Mais Benefícios" ou digite o código...</p>
        </div>
      </div>
    </div>
    <form @submit.prevent="addProdutos" action="#" method="get" v-if="!mensagemSolicitacao">
      <div class="row">
        <div class="col-md-6">
          <FormHelper
            :inputVar="formProduto.produto"
            :form="formProduto"
            label="Código do Produto"
            placeholder="exe: 2220"
          ></FormHelper>
        </div>
        <div class="col-md-2">
          <div style="padding-top: 24px;">
            <button aria-label="Buscar" class="btn primary-button">
              <i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>
        <div class="col-md-4 text-right">
          <h6>
            <strong>Saldo disponivel: A$ {{formatN2(this.formProduto.saldoAldo)}}</strong>
          </h6>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <vue-good-table
            :columns="columns"
            :rows="this.formProduto.produtos"
            :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 20,
                position: 'top',
                perPageDropdown: [40, 60],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'Próximo',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Linhas por página',
                ofLabel: 'de',
                pageLabel: 'page',
                allLabel: 'Todos',
            }"
          >
            <template slot="table-row" slot-scope="props" ref="my-table">
              <span
                v-if="props.column.field == 'vlTotal' || props.column.field == 'vlUnit'"
              >{{formatCurrency(props.formattedRow[props.column.field])}}</span>

              <span v-else-if="props.column.field == 'descricao'">
                {{props.formattedRow[props.column.field]}}
                <br>
                <small>Múltiplo de: {{props.row.qtde}} un.</small>
              </span>
              <button
                aria-label="Remover"
                class="btn btn-danger btn-xs"
                v-else-if="props.column.field == 'id'"
                v-on:click.prevent="remove(props.index)"
              >
                <i class="fa fa-remove"></i>
              </button>
              <div class="row-in-form" v-else-if="props.column.field == 'qtde'">
                <input
                  class
                  type="number"
                  min="1"
                  v-bind:value="props.formattedRow[props.column.field]"
                  v-on:change="calc($event.target.value,props)"
                >
              </div>
              <span v-else>{{props.formattedRow[props.column.field]}}</span>
            </template>
            <div slot="emptystate">Sem dados para exibição</div>
          </vue-good-table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <h6>
            <strong>Total da Solicitação: {{formatCurrency(this.formProduto.totalProdutos)}}</strong>
          </h6>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="choose-checkbox-methods">
            <label class="checkbox-option">
              <input
                name="aceitoTerms"
                value="1"
                type="checkbox"
                checked
                v-model="formProduto.aceitoTerms"
              >
              <span>
                Li e estou de acordo com o
                <a
                  href="#"
                  data-toggle="modal"
                  data-target="#default-modal"
                  @click.prevent="showModal=true"
                >regulamento</a> do programa ALDO CRAZY CARD.
              </span>
            </label>
          </div>
        </div>
        <div class="col-md-6 text-right">
          <button aria-label="Cancelar" class="btn btn-warning" @click.prevent="cancelar()">
            <i class="fa fa-remove"></i> Cancelar
          </button>
          &nbsp;
          <button aria-label="Finalizar" class="btn btn-primary" @click.prevent="finalizar()">
            <i class="fa fa-save"></i> Finalizar
          </button>
        </div>
      </div>
    </form>

    <modal-default title="Regulamento" width="90" v-if="showModal" @close="showModal = false">
      <CrazyRegulament></CrazyRegulament>
    </modal-default>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import FormHelper from "../FormHelper.vue";
import ModalDefault from "../ModalDefault.vue";
import CrazyRegulament from "./CrazyRegulament.vue";

export default {
  name: "CrazyRescueRequest",
  components: {
    VueGoodTable,
    FormHelper,
    ModalDefault,
    CrazyRegulament
  },
  data() {
    return {
      showModal: false,
      codigoSolicitacao: 0,
      mensagemSolicitacao: '',
      formProduto: {
        produto: new this.formInput(),
        aceitoTerms: new this.formInput(true, false),
        attemptSubmit: false,
        produtos: [],
        totalProdutos: 0,
        saldoAldo: 0        
      },
      columns: [
        { label: "Código", field: "codigo" },
        { label: "Descrição", field: "descricao" },
        { label: "Qtde", field: "qtde" },
        { label: "Valor Total", field: "vlTotal", type: "decimal" },
        { label: "Valor", field: "vlUnit", type: "decimal" },
        {
          label: "",
          field: "id",
          tdClass: "align-center-td",
          thClass: "align-center-td"
        }
      ]
    };
  },
  mounted() {
    this.criaSolicitacao()
  },
  methods: {
    formInput: function(required, value) {
      // Define um padrão para estrutura de cada input do formulário
      this.required = required !== undefined ? required : true;
      this.value = value !== undefined ? value : "";

      this.validation = {
        // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !this.required,
        message: this.required ? "Por favor, preencha o campo acima" : ""
      };
    },
    formatCurrency: function(v) {
      v = v.toString().replace(',','.')
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato).replace("R$", "A$");
    },
    formatN2: function(v) {
      var formato = {
        minimumFractionDigits: 2,
        style: "decimal"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    },
    addProdutos: function(event) {
      this.formProduto.attemptSubmit = true;

      if (this.formProduto.produto.value == "") {
        return;
      }      

      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        if (xhr.status == 200){
          let json = JSON.parse(xhr.responseText)
          if (!json.IncluirProdutoEmSolicitacaoResult)
          {
            swal({
              title: json.mensagemSaida,
              icon: "warning"
            })
          }
          else
          {
            this.getProdutos()
          }
        }
      }
      
      xhr.open("POST", this.$apiUrl + "Resgate.svc/incluirproduto")
      xhr.setRequestHeader("Content-type", "application/json")
      xhr.withCredentials = true
      xhr.send(JSON.stringify({
        codigoSolicitacao: this.codigoSolicitacao,
        codigoProduto: this.formProduto.produto.value
      }))            

      this.formProduto.produto.value = null;
      this.formProduto.attemptSubmit = false;

      this.calcSumary();
    },
    calcSumary: function() {
      this.formProduto.totalProdutos = 0;

      for (let i = 0; i < this.formProduto.produtos.length; i++) {
        this.formProduto.totalProdutos += this.formProduto.produtos[i].vlTotal;
      }
    },
    calc: function(newValue, model) {
      if (newValue < 1) {
        return false;
      }

      let qtde = newValue;
      let codigoProduto = this.formProduto.produtos[model.index].codigo;

      this.formProduto.produtos[model.index].qtde = newValue;
      this.formProduto.produtos[model.index].vlTotal =
        parseFloat(model.row.vlUnit) * newValue;    

      var xhr = new XMLHttpRequest()

      xhr.onload = () => {
        if (xhr.status == 200){
          let json = JSON.parse(xhr.responseText)

          if (!json.AlterarQuantidadeResult){
            swal({
              title: json.msgSaida,
              icon: "warning"
            })
            if (json.msgSaida.includes("ultrapassa") || (json.msgSaida.includes("suficiente"))){
              this.formProduto.produtos[model.index].qtde = json.limiteResgate;
              this.formProduto.produtos[model.index].vlTotal =
                parseFloat(model.row.vlUnit) * (newValue - 1);

              this.calcSumary()
            }
          }
        }
      }

      xhr.open("POST", this.$apiUrl + "Resgate.svc/alterarquantidade")
      xhr.setRequestHeader("Content-type", "application/json")
      xhr.withCredentials = true
      xhr.send(JSON.stringify({
        qtde: newValue,
        codigoProduto: codigoProduto,
        codigoSolicitacao: this.codigoSolicitacao
      }))

      this.calcSumary();
    },
    remove: function(x) {
      //remove o item do array

      var someArray = this.formProduto.produtos;
      var _this = this;
      let options = {
        okText: "Sim",
        cancelText: "Não"
      };
      this.$dialog
        .confirm("Deseja realmente excluir o item?", options)
        .then(function(dialog) {
          //caso confirmado sim deve deletar

          let xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200){
              let json = JSON.parse(xhr.responseText)

              if (json.ExcluirProdutoDaSolicitacaoResult){
                swal({
                  title: "Produto excluído com sucesso!",
                  icon: "success"
                })

                _this.getProdutos()
              }
            }
          }

          xhr.open("POST", _this.$apiUrl + "Resgate.svc/excluirproduto")
          xhr.setRequestHeader("Content-type", "application/json")
          xhr.withCredentials = true
          xhr.send(JSON.stringify({
            codigoSolicitacao: _this.codigoSolicitacao,
            codigoProduto: _this.formProduto.produtos[x].codigo
          }))

          $.each(someArray, function(i) {
            if (i === x) {
              someArray.splice(i, 1);
              return false;
            }
          });
          _this.calcSumary();
        });
    },
    finalizar: function() {      
      if (this.formProduto.produtos.length <= 0) {
        let options = {
         verification: 'OK'
        };
        this.$dialog.alert("Nenhum item selecionado?",options);
        
      }
      else {
        let xhr = new XMLHttpRequest()        
        xhr.onload = () => {          
          if (xhr.status == 200){
            swal({
              title: "Solicitação finalizada com sucesso!",
              icon: "success"
            }).then(() => this.limparTela())            
          }
          else {
            let json = JSON.parse(xhr.responseText)
             swal({
              title: json.msgSaida,
              icon: "warning"
            })           
          }          
        }

        xhr.open("POST", this.$apiUrl + "Resgate.svc/finalizarsolicitacao")
        xhr.setRequestHeader("Content-type", "application/json")
        xhr.withCredentials = true
        xhr.send(JSON.stringify({
          codigoSolicitacao: this.codigoSolicitacao
        }))
      }
    },
    cancelar: function() {
      let xhr = new XMLHttpRequest()

      xhr.onload = () => {
        if (xhr.status == 200){
          swal({
            title: "Solicitação cancelada com sucesso",
            icon: "success"
          })

          this.formProduto.produtos = []
          this.formProduto.totalProdutos = 0;
        }
        else {
          swal({
            title: "Erro ao cancelar a Solicitação",
            icon: "error"
          })
        }
      }

      xhr.open("POST", this.$apiUrl + "Resgate.svc/cancelarsolicitacao")
      xhr.setRequestHeader("Content-type", "application/json")
      xhr.withCredentials = true
      xhr.send(JSON.stringify({
        codigoSolicitacao: this.codigoSolicitacao,
        codigoUsuario: 94
      }))
    },
    criaSolicitacao: function() {
      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        if (xhr.status == 200){
          let json = JSON.parse(xhr.responseText)

          if (json.Mensagem){
            this.mensagemSolicitacao = json.Mensagem
          }

          this.codigoSolicitacao = json.CodigoSolicitacao;
          this.formProduto.saldoAldo = json.SaldoDisponivel;

          this.getProdutos();
        }
        else if (xhr.status == 401){
          swal({
            title: "É necessário estar logado",
            icon: "warning"
          }).then(() => location.href = '/login?redirectTo=' + location.href)
        }
      }

      xhr.open("POST", this.$apiUrl + "Resgate.svc/criasolicitacao")
      xhr.setRequestHeader("Content-type", "application/json")
      xhr.withCredentials = true
      xhr.send(JSON.stringify({
        codigoUsuario: 0
      }))
    },
    getProdutos: function(){
      this.formProduto.produtos = []

      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200){
          let produtos = JSON.parse(xhr.responseText)

          produtos.forEach((element) => {
            let produto = {}
            produto.codigo = element.CodigoProduto
            produto.descricao = element.Descricao
            produto.qtde = element.Qtde
            produto.vlUnit = element.ValorUnitario
            produto.vlTotal = element.ValorTotal
            this.formProduto.produtos.push(produto)
          })

          this.calcSumary()
        }
      }

      xhr.open("GET", this.$apiUrl + "Resgate.svc/getprodutos/" + this.codigoSolicitacao)
      xhr.setRequestHeader("Content-type", "application/json")
      xhr.withCredentials = true
      xhr.send()
    },
    limparTela: function() {
      this.formProduto.produtos = []
      this.formProduto.totalProdutos = 0
      this.criaSolicitacao()
    }
  },
};
</script>